/**
 * Serviceplan MAKEOS
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface AccessUserDto { 
    _id: string;
    email: string;
    username: string;
    firstName?: string;
    lastName?: string;
    impersonate?: AccessUserDto;
}

